// 行事曆操作的結果訊息（登入完成、錯誤等），幾秒後自動消失
import { useEffect } from 'react';
import { useCalendar } from '../../calendar/useCalendar.ts';
import { t } from '../../i18n/zh-TW.ts';
import { ICON, X } from '../../ui/icons/index.ts';
import { messageText } from './format.ts';

export function CalendarToast() {
  const cal = useCalendar();
  const message = cal?.message;
  const clear = cal?.clearMessage;
  useEffect(() => {
    if (!message || !clear) return;
    const id = setTimeout(clear, message.kind === 'error' ? 8000 : 4000);
    return () => clearTimeout(id);
  }, [message, clear]);
  if (!message || !clear) return null;
  return (
    <div className={message.kind === 'error' ? 'gcal-toast gcal-toast-error' : 'gcal-toast'} role="status">
      <span>{messageText(message.code)}</span>
      <button type="button" className="icon-btn" onClick={clear} aria-label={t.gcal.close}>
        <X {...ICON} />
      </button>
    </div>
  );
}
